import { Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { isFeuilleDeMatchFull } from '../../utils/feuilleMatch.js'
import { EMPTY_PLAYER } from '../../utils/helpers.js'


import { GAME_FACT_HANDBALL_SHOOTOUT} from '../constants.js'
import TextCustom from '../generic/textCustom.js'
import { useGameFact } from '../useGameFact.js'
import { getTotalTimer, getVisualTimer } from '../../sports/rules.js'

const RecapHandballShootout = ({state, match, onChangeText, onChangeTitle, inHistory}) => {
    const {team, timer, buteur, butSucced, period} = state

    const [img, imgSucceed,imgFailed] = useGameFact({type : GAME_FACT_HANDBALL_SHOOTOUT})

    const {homeHolders, homeSubstitutes, awayHolders, awaySubstitutes, homeTeam, awayTeam} = match

    let allPlayers = isFeuilleDeMatchFull(match) ? [...homeHolders, ...homeSubstitutes, ...awayHolders, ...awaySubstitutes] : [...match.homeTeam.players, ...match.awayTeam.players]

    let buteurPlayer = allPlayers.find(p => p._id === buteur) ?? EMPTY_PLAYER

    let teamSelected = [homeTeam, awayTeam].find(t => t._id === team)

    const actualPeriod = period ??  match.period

    // Gestion du text
    useEffect(() => {
        if(!state.text || state.edited){
            const monText = `Tir au but  ${butSucced ? 'réussi' : 'raté'}${buteurPlayer && buteurPlayer.lastname && buteurPlayer.lastname !== '...' ? ' par ' + buteurPlayer.lastname : ''}!`;
            
            if(!inHistory)
                onChangeText && onChangeText(monText)
        }

        if(!state.title || state.edited){
            const monTitle = 'TIR AU BUT'
            
            if(!inHistory){
                onChangeTitle && onChangeTitle(monTitle)
            }
                
        }
    }, [])

    return (
        <div style={{color : inHistory ? 'black' : 'white'}}>
            <img src={butSucced ? imgSucceed : imgFailed} width={150}/>
            <Typography>Equipe : {teamSelected.name}</Typography>
            <Typography>
                {buteurPlayer && buteurPlayer.lastname && buteurPlayer.lastname !== '...'
                    ? `Joueur : ${buteurPlayer.lastname} ` 
                    : ''}
                ({butSucced ? 'Réussi' : 'Raté'})
            </Typography>
            {(timer !== 0 || period !== 0) && <Typography>Minute : {getVisualTimer(actualPeriod, timer, match.discipline)}</Typography>}
        
            {state.title && <TextCustom initialText={state.title} onChangeText={onChangeTitle} label={'Titre'}/>}
            {state.text && <TextCustom initialText={state.text} onChangeText={onChangeText} label={'Texte'}/>}
        </div>
    )
}

export default RecapHandballShootout